import React from "react";
import { UTILS } from "utils";

const possibleCancelledStatuses = ["CANCELED", "CANCELLED", "CANCELLED_BY_CUSTOMER", "CANCELLED_BY_MERCHANT", "CANCELLED_BY_SYSTEM"];
export const isLogisticServiceOrderCancelled = (order) => {
  
  return possibleCancelledStatuses?.includes?.(order?.logisticPartnerMetadata?.[order?.logisticPartner]?.deliveryStatus?.toUpperCase() || false);
}

const OrderButton = (props) => {

  const { btnText, handleDelivery, deliveyType, order } = props;
  const isSelected = UTILS.getSelectedDelivery(order);
  const isOrderCancelled = isLogisticServiceOrderCancelled(order);

  return (
    <button
      className={`px-4 py-2 me-2 my-2  text-white rounded ${
        isSelected === deliveyType && !isOrderCancelled ? "bg-green-600 " : "bg-gray-600"
      }`}
      onClick={() => handleDelivery(deliveyType)}
    >
      <span className={` ${isSelected === deliveyType && !isOrderCancelled ? "blink" : ""}`}>
        {btnText}
      </span>
    </button>
  );
};

export default OrderButton;
